import { load } from '@fingerprintjs/fingerprintjs';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  token: null,
};
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.token = null;
      localStorage.removeItem('token');
    },
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
